import React from "react"
import { useLocation } from "react-router-dom"
import { useAppSelector } from "../../store"
import { ENTREPRENEURS_SLUG, entrepreneursOverrides } from "../../configs/entrepreneursOverrides"
import HeroAnswer1 from "../../assets/images/svg/hero/hero_thinking.svg"
import HeroAnswer2 from "../../assets/images/svg/hero/hero_timer.svg"
import HeroAnswer3 from "../../assets/images/svg/hero/hero_calendar.svg"
import { Variants } from "../../configs/configs.types"
import answer1V2 from "../../assets/images/answer_01_v2.svg"
import answer3V2 from "../../assets/images/answer_02_v2.svg"
import answer2V2 from "../../assets/images/answer_03_v2.svg"
import answer4V2 from "../../assets/images/answer_04_v2.svg"
import answer1V1 from "../../assets/images/answer_01_v1.svg"
import answer2V1 from "../../assets/images/answer_02_v1.svg"
import answer3V1 from "../../assets/images/answer_03_v1.svg"
import answer1V3 from "../../assets/images/answer_01_v3.svg"
import answer2V3 from "../../assets/images/answer_02_v3.svg"
import answer3V3 from "../../assets/images/answer_03_v3.svg"
import answer4V3 from "../../assets/images/answer_04_v3.svg"

import "./answer.sass"

const IMAGES = [HeroAnswer1, HeroAnswer2, HeroAnswer3]

const variant = process.env.REACT_APP_VARIANT ?? Variants.v0

const answersV1: Record<number, string> = {
  1: answer1V1,
  2: answer2V1,
  3: answer3V1
}

const answersV2: Record<number, string> = {
  1: answer1V2,
  2: answer2V2,
  3: answer3V2,
  4: answer4V2
}

const answersV3: Record<number, string> = {
  1: answer1V3,
  2: answer2V3,
  3: answer3V3,
  4: answer4V3
}

// Функция для получения вариантов данных блока ответа
function getAnswerBlockData(item: any) {
  if (!item.variantsData || variant === Variants.v0 || variant === Variants.v5) {
    return {
      title: item.title,
      description: item.description
    }
  }

  const variantData = item.variantsData[variant]
  if (variantData) {
    return {
      title: variantData.title || item.title,
      description: variantData.description || item.description
    }
  }

  return {
    title: item.title,
    description: item.description
  }
}

export function Answer() {
  const dataConfig = useAppSelector(state => state.configs.general.data?.main)
  const { pathname } = useLocation()
  const isEntrepreneursPage = pathname.includes(ENTREPRENEURS_SLUG)

  if (variant === "v1") {
    return (
      <div className="answer">
        {(dataConfig?.answerBlock ?? []).map((item, idx) => {
          const blockData = getAnswerBlockData(item)
          const description = isEntrepreneursPage && entrepreneursOverrides.answerDescriptions[item.id]
            ? entrepreneursOverrides.answerDescriptions[item.id]
            : blockData.description
          return (
            <div className="answer-pic-text" key={item.id}>
              <img src={answersV1[idx + 1]} alt="answer-pic-1" />
              <h3 className="answer-text-header">{blockData.title}</h3>
              <p className="answer-text-description">{description}</p>
            </div>
          )
        })}
      </div>
    )
  }

  if (variant === "v2") {
    return (
      <div className="answer">
        {(dataConfig?.answerBlock ?? []).map((item, idx) => {
          const blockData = getAnswerBlockData(item)
          return (
            <div className="answer-pic-text" key={item.id}>
              <img src={answersV2[idx + 1]} alt="answer-pic-1" />
              <span className="text">
                <h3>{blockData.title}</h3>
                <p>{blockData.description}</p>
              </span>
            </div>
          )
        })}
      </div>
    )
  }

  if (variant === "v3") {
    return (
      <div className="answer">
        {(dataConfig?.answerBlock ?? []).map((item, idx) => {
          const blockData = getAnswerBlockData(item)
          return (
            <div className="answer-pic-text" key={item.id}>
              <img className="answer-pic" src={answersV3[idx + 1]} alt="answer-pic-1" />
              <p>{blockData.description}</p>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className="answer">
      {(dataConfig?.answerBlock ?? []).map((item, idx) => {
        const blockData = getAnswerBlockData(item)
        // Для варианта v0 всегда используем локальные SVG-иконки по индексу,
        // чтобы иконки гарантированно были на всех элементах независимо от конфига
        const iconUrl = IMAGES[idx % IMAGES.length]
        return (
          <div className="answer__item" key={item.id}>
            <div className="answer__img">
              {iconUrl && (
                <img src={iconUrl} alt="" className="answer__img-picture" />
              )}
            </div>
            <div className="answer__text">
              <h3 className="answer__title">{blockData.title}</h3>
              <p className="answer__description">{blockData.description}</p>
            </div>
          </div>
        )
      })}
    </div>
  )
}
